import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useAppDispatch } from '@/store'

import { selectVehiclesMapStyles, setCustomMapStyle } from '@/features/domain/ui'

export function useVisibility(id: string) {
  const dispatch = useAppDispatch()
  const mapStyles = useSelector(selectVehiclesMapStyles)

  const globalStyle = mapStyles.mode
  const customStyle = mapStyles.custom[id]
  const mode = customStyle || globalStyle

  return [
    mode !== 'off',
    useCallback<React.MouseEventHandler<HTMLDivElement>>(
      e => {
        e.stopPropagation()
        dispatch(
          setCustomMapStyle({
            customStyle: { type: 'vehicle', mode: mode !== 'off' ? 'off' : 'on', ids: [id] },
          }),
        )
      },
      [mode, dispatch, id],
    ),
  ] as const
}
